import type React from 'react'
import type { IconProps } from './types'

const PinIcon: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 32 32'
		className={className}
		fill='currentColor'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M23.1672 4.50104V7.16771H21.8339V18.0677L19.1672 15.401V7.16771H13.8339V10.0677L10.9339 7.16771L9.83385 6.06771V4.50104H23.1672ZM16.5005 31.1677L15.1672 29.8344V21.8344H8.50052V19.1677L11.1672 16.501V14.9677L2.36719 6.10104L4.23385 4.23438L28.7672 28.7677L26.8339 30.6344L18.0339 21.8344H17.8339V29.8344L16.5005 31.1677ZM12.3005 19.1677H15.3672L13.9005 17.701L13.8339 17.6344L12.3005 19.1677Z' />
	</svg>
)

export default PinIcon
